import { ComponentProps } from 'react';

import { AlternateVersionHelper } from 'core/helpers';
import { QuoteEntityType, QuoteType } from 'quotes/enums';
import { useCustomerQuotePartsContext, useSelectedQuotePartContext } from 'quotes/states';
import { IBaseQuote } from 'quotes/types';

import { IsLineEditable } from './nextLine';
import { UpsertLineSteps } from './UpsertLineSteps';

interface IProps {
  quote: IBaseQuote;
  quoteType?: QuoteType;
  isOpen: boolean;
  onClose: () => void;
  onSubmitSuccess?: () => void;
  alternate?: boolean;
  entityType?: QuoteEntityType;
  // Offers Next Line, walking the grid's displayed lines this predicate lets Edit Line open.
  isLineEditable?: IsLineEditable;
}

// Only a customer quote's list sits inside CustomerQuotePartsProvider; a vendor's stays off it.
const CustomerUpsertLineSteps = (props: ComponentProps<typeof UpsertLineSteps>) => {
  const { currentQuoteVersion } = useCustomerQuotePartsContext();

  return <UpsertLineSteps {...props} quoteVersion={currentQuoteVersion} />;
};

export const QuotePartUpsertLine = ({
  quote,
  quoteType = QuoteType.CUSTOMER,
  isOpen,
  onClose,
  onSubmitSuccess = null,
  alternate = false,
  entityType,
  isLineEditable,
}: IProps) => {
  const { selectedQuotePart, selectQuotePart } = useSelectedQuotePartContext();

  const isAlternateVersionEnabled = AlternateVersionHelper.isAlternateVersionEnabled({
    quote,
  });

  const Steps = QuoteType.CUSTOMER === quoteType ? CustomerUpsertLineSteps : UpsertLineSteps;

  return (
    <Steps
      quoteId={quote.id}
      quoteType={quoteType}
      quotePart={selectedQuotePart}
      alternate={alternate}
      isEdit={!!selectedQuotePart?.id}
      isOpen={isOpen}
      onClose={onClose}
      onSubmitSuccess={onSubmitSuccess}
      quote={quote}
      isAlternateVersionEnabled={isAlternateVersionEnabled}
      entityType={entityType}
      isLineEditable={isLineEditable}
      onOpenLine={isLineEditable ? selectQuotePart : undefined}
    />
  );
};
